import { z } from 'zod';
import { baseStudyEntityValidationSchema } from '../validation/index.js';
import { IllegalArgumentError } from 'faro-common-model';
import { StudyEntityType } from '../study-entity-type.js';
import { uuidish } from '../../utils/uuidish.js';
export const assessmentMeasurementConfigurationGroupSchema = z.object({
    ...baseStudyEntityValidationSchema.shape,
    entityType: z
        .literal(StudyEntityType.AssessmentMeasurementConfigurationGroup)
        .default(StudyEntityType.AssessmentMeasurementConfigurationGroup),
    studyAssessmentMeasurementId: uuidish,
    assessmentMeasurementConfigurationIds: z.array(z.string()),
});
export function toAssessmentMeasurementConfigurationGroup(group) {
    const result = assessmentMeasurementConfigurationGroupSchema.safeParse(group);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementConfigurationGroup object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-configuration-group.js.map